/**
 * A v4 UUID from the browser's crypto. `crypto.randomUUID` exists only in a
 * secure context (https, or localhost); on plain http over a LAN name — how a
 * dev box is often reached from a phone — `getRandomValues` still does, so
 * the id is assembled from 16 random bytes with the v4 bits set.
 *
 * Used for client-side correlation ids: the Data Mapper's per-tab id and the
 * progress token a container-action dialog sends with its request.
 */
export const newUuid = (): string => {
  const c = globalThis.crypto as Crypto | undefined;
  if (c?.randomUUID) return c.randomUUID();
  const b = new Uint8Array(16);
  c?.getRandomValues?.(b);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
};
